<app-view-title Title="{{ 'Intellitrailer.Rental.Component.HeadLampsInfo.ActiveTrailer' | translate : 'Active Trailer' }}" mode="soft"></app-view-title>
<view-content [centered]="true">

  <img src="/Images/lightknob_full_icon.png" />

  @if(searching && !searchSucceeded){
  <h2 class="searching-indicator">{{ 'Intellitrailer.Rental.Component.HeadLampsInfo.txtSearchingTrailer' | translate :'Searching for trailer' }}</h2>
  <div class="componentLoader">
    <mat-progress-spinner *ngIf="searching"
                          mode="determinate"
                          [value]="searchProgress"
                          diameter="48">
    </mat-progress-spinner>
  </div>
  }
  @if(searchSucceeded){

  <h2 class="searching-found"> {{ 'Intellitrailer.Rental.Component.HeadLampsInfo.txtTrailerFound' | translate :'Trailer found!' }}</h2>
  }

  <app-card>
    <ul class="headlamp-steps">
      <li>
        <mat-icon [class.completed]="checklistStep >= 1" [class.pending]="checklistStep < 1">{{ checklistStep >= 1 ? 'check_circle' : 'cancel' }}</mat-icon>
        <span>{{ 'Intellitrailer.Rental.Component.HeadLampsInfo.txtCheckList1' | translate :'Connect it to the car' }}</span>
      </li>
      <li>
        <mat-icon [class.completed]="checklistStep >= 2" [class.pending]="checklistStep < 2">{{ checklistStep >= 2 ? 'check_circle' : 'cancel' }}</mat-icon>
        <span>{{ 'Intellitrailer.Rental.Component.HeadLampsInfo.txtCheckList2' | translate :'Start the engine'}}</span>
      </li>
      <li>
        <mat-icon [class.completed]="checklistStep >= 3" [class.pending]="checklistStep < 3">{{ checklistStep >= 3 ? 'check_circle' : 'cancel' }}</mat-icon>
        <span>{{ 'Intellitrailer.Rental.Component.HeadLampsInfo.txtCheckList3' | translate :'Turn off automatic headlights and set the lights to manual mode' }} </span>
      </li>
    </ul>
  </app-card>

</view-content>

<view-actions mode="white">
  @if(!searchSucceeded){
    @if(!isChecklistCompleted){
  <button mat-raised-button color="primary" [disabled]="searching" (click)="advanceChecklist(); checklistStep === 3 && searchForConnection()">{{ 'Intellitrailer.Rental.Component.HeadLampsInfo.btn_' + currentChecklistButtonLabel | translate :currentChecklistButtonLabel }}</button>
    }
    @else{
  <button mat-raised-button color="primary" [disabled]="searching" (click)="searchForConnection()">{{ 'Intellitrailer.Rental.Component.HeadLampsInfo.btnCheckConnection' | translate :'Check Connection' }}</button>
    }
  }
  @else{
  <button mat-raised-button color="primary" [disabled]="!searchSucceeded" (click)="goingToNext()">{{ 'Intellitrailer.Rental.Component.HeadLampsInfo.btnNext' | translate :'Next' }}</button>
  }
</view-actions>


